// Copyright (c) 2017 Deere & Company

import ClaimsInProgress from './claims-in-progress';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';
import {getWipStatuses} from '../services/claims-in-progess-helper';

const getStateToBindToContainerProps = state => ({
    ...state.claims.claimsInProgress,
    allowedStatuses: getWipStatuses(state.user.details.settings.claims.status.allowedStatuses),
    exportToExcel: state.exportToExcel,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    pathName: parentProps.location.pathname,
    queryParams: parentProps.location.query
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimsInProgress);



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/components/index.js